__turbopack_context__.v({
  "authTypes": "two-factor-module-sass-module__fMQvmq__authTypes",
  "checkmark": "two-factor-module-sass-module__fMQvmq__checkmark",
  "compact": "two-factor-module-sass-module__fMQvmq__compact" + " " + __turbopack_context__.i(77712)["blockContent"],
  "compactHeader": "two-factor-module-sass-module__fMQvmq__compactHeader",
  "enabled": "two-factor-module-sass-module__fMQvmq__enabled",
  "twoStepAuth": "two-factor-module-sass-module__fMQvmq__twoStepAuth",
});
